import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Team = ({ team, url }) => (
  <Link
    to={url}
    className="s-teams__item is-fade-loaded"
    key={team.id}
    title={team.name}
  >
    <div
      className={`card-image-right ${team.preferred ? 'is-preferred' : ''} ${
        team.secondary ? 'is-secondary' : ''
      }`}
    >
      <p className="s-teams__name">
        {team.preferred && <span className="s-teams__preferred">&#11089;</span>}
        {team.name}
      </p>
      <div
        className="card-image-right__image"
        style={{
          backgroundImage: `url(${team.image})`,
        }}
      />
    </div>
  </Link>
);

Team.propTypes = {
  team: PropTypes.object.isRequired,
};

export default Team;
